<template>
<section>
    <h1 class="main-title first-title grid-container layer1">Shows</h1>
    <div class="mobile-navigation shows layer3"></div>
    
    <div class="grid-100 grid-parent layer1">
        <div class="grid-container">
            <div class="tour-dates grid-60 push-40">
                <Loader :active="!showsLoaded"></Loader>
                <div class="tour-group-wrapper" v-bind:class="{ open: tour.open, close: !tour.open }" v-for="tour in tours" :key="tour.id">
                    <h4 class="tour-name" v-bind:class="{ open: tour.open, close: !tour.open }" v-on:click="openTour(tour)" v-html="tour.title.rendered"></h4>
                    <div class="tour-wrapper" v-bind:class="{ open: tour.open, close: !tour.open }" >
                        <div class="shows-month-wrapper"  v-for="(month, index) in tour.shows" v-if="month && index === 0" :key="month.name">
                        <h4 class="month">{{ month.name }}</h4>
                        <ul class="tour-list">
                            <li v-for="(show, index) in month.shows" class="tour-event grid-100 grid-parent" :key="show.show_date" v-if="show && show.show_date && index < 4">
                                <span class="date">{{$parent.getDateInFormat(show.show_date)}}</span>
                                <span class="location">{{show.place}} </span>
                                <span>
                                <a class="buy layer1" v-bind:href="show.tickets_link" target="_blank"><span
                                        class="tour-cta">Buy Tickets </span></a>
                                <a class="buy layer1" v-bind:href="show.tickets_link" target="_blank"><span
                                        class="tour-cta-mobile">Buy </span></a>
                                </span>
                            </li>
                        </ul>
                        <div class="more-cta">
                            <router-link :to="{ name: 'Shows', params: { tour: tour.slug } }" class="layer1">
                                <span>More Shows</span>
                                <img src="../../assets/images/arrow_home_cta.png"/>
                            </router-link>
                        </div>
                        </div>
                    </div>
                </div>
                <span class="no-shows" v-show="tours.length === 0">Sorry, there are no dates available</span>
            </div>
        </div>
    
        <div class="tour-wrapper grid-container">
            <div class="home-cta grid-50 push-50">
                <a href="#/shows" class="layer1">
                    <span>See All Shows</span>
                    <img src="../../assets/images/arrow_home_cta.png"/>
                </a>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import Loader from '../Loader'

export default {
    name: "ShowsList",
    components: {
        Loader,
    },
    props: {
        tours: {
            type: Array,
            required: true,
        },
        showsLoaded: {
            type: Boolean,
            required: true,
        },
        openTour: {
            type: Function
        }
    },
};
</script>


// WEBPACK FOOTER //
// Shows.vue?29f074fc